import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        project: store.project,
        settings: store.settings
    }
})

class UserType extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const types = [
            {value: "new", label: "New User"},
            {value: "existing", label: "Existing User"}
        ];

        return (
            <Select 
                classes={{options: `addUsersSelection`}}
                placeholder="Select"
                options={types}
                selected={this.props.selected}
                onChange={this.props.onChange}
                isClose={this.props.isClose}
                isFirstItemSelected={false}
            />
        );
    }
}

export default UserType;